<template>
	<div class="inspiration-container height-100" :class="{ show: useShowInspirationCenter }">
		<template v-if="useShowInspirationCenter">
			<div class="close-btn">
				<!-- CLOSE BUTTON -->
				<v-btn @click.stop="closeInspirationCenter">
					<SIcon name="close" />
				</v-btn>
			</div>
			<InspirationCenterMenuContent />
		</template>
	</div>
</template>

<script>
import { useShowInspirationCenter } from '@/store/modules/appLayout/getters';
import { setShowInspirationCenter } from '@/store/modules/appLayout/actions';
import { mapGettersShorthand, mapActionsShorthand } from '@/store/utils/mappers';
import InspirationCenterMenuContent from '@/components/InspirationCenter/InspirationCenterMenuContent.vue';
export default {
	name: 'InspirationCenter',
	components: { InspirationCenterMenuContent },
	computed: {
		...mapGettersShorthand({ useShowInspirationCenter }),
	},
	methods: {
		...mapActionsShorthand({ setShowInspirationCenter }),
		closeInspirationCenter() {
			this.setShowInspirationCenter({ showInspirationCenter: false });
		},
	},
};
</script>

<style lang="scss" scoped>
.inspiration-container {
	top: 0px;
	z-index: 2;
	bottom: 0px;
	width: 780px;
	right: -780px;
	transition: 1s;
	position: fixed;
	border-radius: 10px 0 0 10px;
	border-left: 1px solid #dfdfe2;
	background: var(--primary-bg-color);
	box-shadow: -5px 0px 6px #00000021;
	&.show {
		right: 0px;
	}
}
.collapse-button {
	$button-size: 18px;
	border-radius: 6px;
	position: absolute;
	padding: 0px !important;
	margin-left: -$button-size;
	top: calc(50% - (#{$button-size} / 2));
}
.close-btn {
	top: 20px;
	left: -60px;
	position: absolute;
	border-radius: 4px;
	box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.2) !important;

	::v-deep {
		button {
			width: 50px;
		}
		svg {
			margin-top: 8px;
		}
	}
}
.rotate {
	transition: 0.3s;
	transform: rotate(180deg);
}
</style>
